import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function InternShip() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            インターンシップのご案内
          </Typography>
          　デーリー東北新聞社は、２０２１卒の大学生と大学院生を対象とした「1ＤＡＹインターンシップ」を開催します。参加する学生を募集しています。
        </Box>
        <Box my={8}>
          <dl>
            <dt>開催日時</dt>
            <dd>２０２０年２月１４日（金）　午前１０時～午後５時</dd>
            <dt>場所</dt>
            <dd>デーリー東北新聞社</dd>
            <dt>定員</dt>
            <dd>８人</dd>
            <dt>内容</dt>
            <dd>
              <ol>
                <li>会社説明</li>
                <li>先輩記者との懇談</li>
                <li>隣接する「しんぶんカフェ」で昼食</li>
                <li>取材、執筆</li>
                <li>会社見学　etc</li>
              </ol>
            </dd>
          </dl>
          ※取材・執筆にはフィードバックを予定しています。
        </Box>

        <Box my={4} className="text-center">
          <a href="https://job.career-tasu.jp/2021/icorp/00104330/list/index/?cid=polnk21_01_180601" target="TRG_CORP_00104330">
            <img src="https://support.disc.co.jp/2021/information/file/logo_2021intern_l.gif" alt="キャリタス就活2021" width="238" height="60" />
          </a>
        </Box>

        <Box my={8}>
          　不明な点や問い合わせなどありましたら、デーリー東北新聞社インターンシップ担当　電話０１７８（４４）５１１１までお問い合わせ下さい。
        </Box>

      </div>
    </div>
  );
}

export default InternShip;
